module.exports = __webpack_public_path__ + "img/no-image.46097888.jpg";